/* eslint-disable no-unused-vars */
import Vue from "vue";
import store from "./store";

import App from "./App.vue";

import router from "./router";

import VueMaterial from "vue-material";
import mgr from "./authService.js";
import VueToast from "vue-toast-notification";
import VueHtmlToPaper from "vue-html-to-paper";
// import FullStory from './assets/js/fullstory'

import moment from "moment";

// import { MdButton, MdContent, MdTabs } from 'vue-material/dist/components'
// import 'bootstrap'
import "../src/assets/css/bundle.min.css";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import "vue-toast-notification/dist/theme-sugar.css";
import "../src/styles/styles.scss";

Vue.prototype.moment = moment;
// ================== global constants ==================
Vue.prototype.$app_version = process.env.VUE_APP_VERSION;
Vue.prototype.$gift_word = process.env.VUE_APP_GIFT_WORD;
// ================== global constants ==================


Vue.use(VueToast);
Vue.use(VueMaterial);
Vue.use(VueHtmlToPaper);
Vue.config.productionTip = false;

const globalData = {
	isAuthenticated: false,
	user: "",
	mgr: mgr,
};
const globalMethods = {
	async authenticate(returnPath) {
		const user = await this.$root.getUser(); //see if the user details are in local storage
		if (!!user) {
			this.isAuthenticated = true;
			this.user = user;
		} else {
			await this.$root.signIn(returnPath);
		}
	},
	async getUser() {
		try {
			let user = await this.mgr.getUser();
			return user;
		} catch (err) {
			console.error(err);
		}
	},
	signIn(returnPath) {
		returnPath
			? this.mgr.signinRedirect({ state: returnPath })
			: this.mgr.signinRedirect();
	},
};

store.watch(
	state => state.userProfile,
	(newVal) => {
		const confirmed = newVal?.[0]?.confirmed === 1

		const pages = [
			"paypal",
			"list",
			"orderhistory",
			"promotionscreen",
			"cart",
			"promo",
			"payment",
			"transactions",
		]

		if (!confirmed) {
			const routeName = router.currentRoute.name.toLowerCase()

			if (pages.includes(routeName)) {
				store.commit("showToast", {
					message: "Please Confirm Your Profile",
					position: "bottom",
					type: "error",
				});
				router.replace({ name: 'profile' })
			}
		}
	},
	{
		deep: true,

	}
)

new Vue({
	router,
	data: globalData,
	methods: globalMethods,
	mixins: globalMethods,
	render: (h) => h(App),
	store,
}).$mount("#app");
